module.exports = __webpack_public_path__ + "img/gb834.prt.72ef46c2.jpg";